// extracted by mini-css-extract-plugin
export var checkoutHoverCard = "_mo-2";
export var interactiveWrapper = "_mo-0";
export var shippingHoverPreview = "_mo-4";
export var summaryBadgeTrigger = "_mo-1";
export var widgetHoverPreviewList = "_mo-3";
export var widgetPreviewScale = "_mo-5";